import React, { useContext, useEffect } from 'react'
import AppTable from '../table/AppTable'
import styles from './SoldTicketError.module.css'
import { CircularProgress } from '@mui/material'
import {  formatDates } from '../../../helper'
import ToasterWithMessage from '../toaster'
import { useMutation } from '@apollo/client'
import { GET_PUBLISH_TICKETS_ERROR } from '../../../features/ErrorDashboard/api/ErrorQuery'
import moment from 'moment'
import { globalContext } from '../../../Provider/AppProvider'

const PublishTicketsError = (props:any) => {
  const {
    rowsPerPagePublish,
    currentPagePublish,
    setCurrentPagePublish,
    checking,
    setChecking,
    publishTicketErrorList,
    setPublishTicketErrorList,
    columnTypes,
    setColumnTypes,
    sortType,
    setSortType,
    selected,
    setSelected,
    datesForApiCall,
    selectedStartDate,
    selectedEndDate,
    GeneratePublishTicketsErrorHeadCells,
    handleChangeRowsPerPagePublish,
    handlePageChangePublish
  } = props;
  const {error} = ToasterWithMessage();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [getPublishTicketsError,{loading}] = useMutation(GET_PUBLISH_TICKETS_ERROR,{
    fetchPolicy: 'no-cache',
    onCompleted: (errorData) => {
        setPublishTicketErrorList(errorData);
    },
    onError: (err) => {
      error("Something went wrong while fetching error data!");
    }
})




const callPublishTicketsErrorApi = () => {
  const startdateForPublishError = datesForApiCall.fromdate
  const enddateForPublishError = datesForApiCall.enddate
  // const payloadEndDate = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
  const formattedDates = formatDates(startdateForPublishError, enddateForPublishError);
  if(moment(startdateForPublishError).isSameOrBefore(enddateForPublishError,'day')){
    let payload = {};
    if(columnTypes){
      payload = {
        "startDate": formattedDates.formattedStartDate,
        "endDate": formattedDates.formattedEndDate,
        "limit": rowsPerPagePublish,
        "offset": (currentPagePublish -1)*rowsPerPagePublish,
        "orderBy": sortType,
        "orderColumn": columnTypes,
        "status" :globalState.errorStatus.publishTicket
    }
    }else {
      payload = {
        "startDate": formattedDates.formattedStartDate,
        "endDate":  formattedDates.formattedEndDate,
        "limit": rowsPerPagePublish,
        "offset": (currentPagePublish -1)*rowsPerPagePublish,
        "orderBy": sortType,
        "status" :globalState.errorStatus.publishTicket
    }
    }
      getPublishTicketsError({
          variables: payload
      })
      const tempState = {...globalState};
      tempState.trigger.publishTicketError = false;
      handleGlobalState(tempState);
      return;
  }else {
      error("From date must be less than to date");
      return;
  }
};

useEffect(() => {
  callPublishTicketsErrorApi();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[selectedStartDate,
   selectedEndDate,
   sortType,
   columnTypes,
   rowsPerPagePublish,
   currentPagePublish,
   globalState.errorStatus.publishTicket
  ]);
  useEffect(() => {
    if(globalState.trigger.publishTicketError===true){
      callPublishTicketsErrorApi();
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
},[globalState.trigger.publishTicketError])
  return (
    <>
    {
        loading
    ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
    :
    <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPagePublish}
        handlePageChange={handlePageChangePublish}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPagePublish}
        setCurrentPage={setCurrentPagePublish}
        currentPage={currentPagePublish}
        list={publishTicketErrorList}
        // list={dummyerrorData}
        tableTitle="publishTicketsError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GeneratePublishTicketsErrorHeadCells}
    />
    }
    </>
  )
}

export default PublishTicketsError